/* eslint global-require: 0 */
import React from 'react';
import {
  Route,
  Switch,
  Redirect,
} from 'react-router-dom';
import PageNotFound from './Pages/PageNotFound';
import Logout from './Pages/Auth/Logout';
import RouteLoader from './Components/RouteLoader';

if (process.env.NODE_ENV === 'test') {
    require.ensure = (deps, cb) => cb(require);
}
const Dashboard = RouteLoader(done =>
    require.ensure('./Pages/Dashboard', () =>
        done(require('./Pages/Dashboard')),
    ));
const Landing = RouteLoader(done =>
    require.ensure('./Pages/Landing', () =>
        done(require('./Pages/Landing')),
    ));
const ForgetPassword = RouteLoader(done =>
    require.ensure('./Pages/ForgotPassword', () =>
        done(require('./Pages/ForgotPassword')),
    ));
const Signup = RouteLoader(done =>
    require.ensure('./Pages/Signup', () =>
        done(require('./Pages/Signup')),
    ));
const GiftCard = RouteLoader(done =>
    require.ensure('./Pages/GiftCard', () =>
        done(require('./Pages/GiftCard')),
    ));
const Contact = RouteLoader(done =>
    require.ensure('./Pages/Contact', () =>
        done(require('./Pages/Contact')),
    ));
const Policy = RouteLoader(done =>
    require.ensure('./Pages/Policy', () =>
        done(require('./Pages/Policy')),
    ));
const ECoaching = RouteLoader(done =>
    require.ensure('./Pages/ECoaching', () =>
        done(require('./Pages/ECoaching')),
    ));

const RedirectToDashboard = () => (<Redirect to="/dashboard/day" />);

const ArchivedRedirect = () => (<Redirect to="/dashboard/journey/history" />);

const Routes = ({ runnerId, archived, themeId }) => (<Switch>
    {!runnerId ? <Route
        path="/dashboard"
        component={Logout}
    /> : <Route
        path="/dashboard"
        render={() => <Switch>
            <Route
                path="/dashboard/upgrade"
                component={ECoaching}
            />
            <Route
                component={Dashboard}
            />
        </Switch>}
    />}
    <Route path="/logout" component={Logout} />
    {archived ? <Route
        path="/"
        exact
        component={runnerId ? ArchivedRedirect : Landing}
    /> : <Route
        path="/"
        exact
        component={runnerId ? RedirectToDashboard : Landing}
    />}
    <Route
        path="/forgot_password"
        component={ForgetPassword}
    />
    <Route
        path="/signup"
        component={isNyrr(themeId) ? Landing : Signup}
    />
    <Route path="/gift" component={GiftCard} />
    <Route path="/contact" component={Contact} />
    <Route path="/terms" component={Policy} />
    <Route path="/policy" component={Policy} />
    <Route component={PageNotFound} />
</Switch>);

export const isNyrr = themeId => [1, 2, 3, 6, 7, 8].includes(+themeId);

Routes.propTypes = {
    runnerId: React.PropTypes.oneOfType([
        React.PropTypes.number,
        React.PropTypes.string,
    ]),
    themeId: React.PropTypes.oneOfType([
        React.PropTypes.number,
        React.PropTypes.string,
    ]),
    archived: React.PropTypes.oneOfType([
        React.PropTypes.number,
        React.PropTypes.boolean,
    ]),
};

export default Routes;



/** WEBPACK FOOTER **
 ** ./src/Routes.js
 **/